<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <!-- <TabellaListaInterventi :rotta_back="'/home/naval'" /> -->
        <Calendar :rotta_back="'/home/naval'" />
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import TabellaListaInterventi from "@/components/MANUTENZIONE/TabellaListaInterventi.vue";
import Calendar from "@/components/MANUTENZIONE/Calendar.vue";

export default {
  name: "DGListaInterventi",
  components: {
    Calendar,
  },
  data() {
    return {
      view: 0,
    };
  },
  methods: {
    goBack() {
      this.view = 0;
    },
  },
};
</script>
